(function () {
  var LEFT_OFFSET = '20px';
  // Chatbase re-renders/re-positions its bubble button, message list, and
  // chat window independently, so all three need to be pinned left.
  var SELECTORS = [
    '#chatbase-message-bubbles',
    '#chatbase-bubble-button',
    '#chatbase-bubble-window',
  ];

  function pinLeft(el) {
    if (!el) return;
    if (el.style.left === LEFT_OFFSET && el.style.right === 'unset') return;
    el.style.setProperty('left', LEFT_OFFSET, 'important');
    el.style.setProperty('right', 'unset', 'important');
  }

  function pinAll() {
    for (var i = 0; i < SELECTORS.length; i++) {
      var els = document.querySelectorAll(SELECTORS[i]);
      for (var j = 0; j < els.length; j++) pinLeft(els[j]);
    }
  }

  function watchElement(el) {
    pinLeft(el);
    var attrObserver = new MutationObserver(function () {
      pinLeft(el);
    });
    attrObserver.observe(el, { attributes: true });
  }

  function init() {
    SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(watchElement);
    });

    var treeObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          SELECTORS.forEach(function (selector) {
            if (node.matches && node.matches(selector)) watchElement(node);
            if (node.querySelectorAll) {
              node.querySelectorAll(selector).forEach(watchElement);
            }
          });
        }
      }
    });
    treeObserver.observe(document.body, { childList: true, subtree: true });

    setInterval(pinAll, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
